<template>
  <div>
    <div class="panel panel-primary">
      <div class="panel-heading padding-0">
        <h3 class="text-center panel-title">
          <a href="#content-message-sets" data-toggle="collapse" class="collapsable-link-panel collapsable-icon-container">
            Message Sets
            <div class="style-new-icon">
              <i class="fa fa-gift" v-on:click.stop.prevent="showInfoPopUp" style="font-size:22px;" aria-hidden="true" title="New Features!"></i>
            </div>
          </a>
        </h3>
      </div>
      <div class="modal-backdrop" v-if="showNewFeaturePrompt">
        <div class="modal new-feature" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" style="height: 415px; width: 518px;">
          <header class="modal-header">
            <div class="header-style">
              <h3>New Features !</h3>
              <i v-on:click="closeNewFeatureModal" class="fa fa-close" style="font-size:22px;color:red" title="Close"></i>
            </div>
          </header>
          <section class="modal-body">
            <div class="style-section">
              <h4 class="style-button-section"><b>Button</b></h4>
              <div>We can now add buttons for message instead of asking the user to type the numbers.</div>
              <div class="style-template-text"><b>Template to use button:- </b></div>
              <div class="style-select-options">Please select one of the following options :- </div> 
              <span>{{ showTextInfoForButton }}</span>
              <h4 class="style-list-section"><b>List</b></h4>
              <div>We can support lists instead of buttons whenever the user has more than 3 options to be selected.</div>
              <div class="style-template-text"><b>Template to use list:- </b></div>
              <div class="style-select-options">Please select one of the following options :- </div> 
              <span>{{ showTextInfoForList }}</span>
              <h4 class="style-list-section"><b>Token</b></h4>
              <div><b>Token to add Account ID </b>(Token would be replaced with user's account id):- <span>{{ showTextInfoForAccountId   }}</span></div>
              <div><b>Token to add Pharmacy Name </b>(currently we are only using in Delay Tactics):- <span>{{ showTextInForPharmacyName }}</span></div>
              <div><b>Token to add User Name </b>(Currently, supported only for Ninety JoR):- <span>{{ showTextInForUserName }}</span></div>
              <div><b>Token to display User Location </b>(The token would get replaced with user location):- <span>{{ showTextInfoForUserLocation }}</span></div>
              <div><b>Token to show map link based on referral </b>(currently used only in message sets):- <span>{{ showTextInfoForMapOfReferral }}</span></div>    
              <div><b>Token to show link of MSK resource in the DDE </b>(currently we are not showing during the msk resource display. So, we have to show it in the DDE via this token):- <span>{{ showTextInfoForMSKLink }}</span></div>    
              <div><b>Use this token to show a gift card or coupon to the user</b>. The number in the token represents the gift card's price. Example:- <span>{{ showTextInfoForGiftCard }}</span> would display a gift card worth amount of 150.</div>
              <div><b>Use this token to display the Nivi digital voucher to the user.</b>.  The voucher format is NIVI-YYMMDD-UNIQUEID. Example:- <span>{{ showTextInfoForDigitalVoucher }}</span> will generate and send a digital voucher code to the user, such as NIVI-250715-X92.</div>
              <div><b>Use this token to send airtime via Africa's Talking to the user</b>. The number in the token represents the airtime in KES. Example:- <span>{{ showTextInfoForAirtime }}</span> would send airtime worth 10 KES.</div>    
              <div><b>Use this token to send appointment booking details to Ninety user</b>. There are 4 tokens for date, time, booking id, and clinic. Example:- <span>{{ showTextInfoForNinetyForAppointment }}</span> This would send the actual data from appointment_booking table</div>    
              <div><b>Token to add Provider code </b>:- <span>{{ showTextInForProviderCode }}</span></div>
            </div>
          </section>
        </div>
      </div>
      <div id="content-message-sets" class="collapse in">
        <div class="panel-body message-table-container">
          <div class="message-set-header">
            <div class="add-message-container">
              <button type="button" v-on:click="addMessage()" class="btn btn-add-message">
                <i class="fa fa-plus" aria-hidden="true"></i> Add Message
              </button>
              <div v-if="formattedMessageSet.length" class="view-option" role="radiogroup" aria-label="Show messages">
                <label v-for="option in viewOptions" :key="option.value" class="view-option-radio" :class="{ 'view-option-radio--active': selectedViewOption === option.value }" v-on:change="toggledRadio">
                  <input type="radio" v-model="selectedViewOption" :value="option.value"/>
                  <i class="fa" :class="option.value === 0 ? 'fa-expand' : 'fa-compress'" aria-hidden="true"></i> {{option.label}}
                </label>
              </div>
            </div>
            <label v-if="formattedMessageSet.length" class="hide-empty-translation" :class="{ 'hide-empty-translation--on': hideEmptyTranslations }">
              <input type="checkbox" v-model="hideEmptyTranslations">
              <span class="hide-empty-translation__track"><span class="hide-empty-translation__thumb"></span></span>
              Hide languages with no translation
            </label>
          </div>
          <div v-if="!formattedMessageSet.length" class="message-empty">
            <i class="fa fa-comment-o" aria-hidden="true"></i>
            <span>No message present for this stage. Click on "Add Message" to add new message</span>
          </div>
          <table v-if="formattedMessageSet.length" class="message-list" style="margin-bottom:0px">
              <draggable v-model="formattedMessageSet" tag="tbody"  v-if="formattedMessageSet && Object.keys(formattedMessageSet).length">
                <tr v-for="(message, index) in formattedMessageSet" :key="index">
                  <message 
                    :message="message" 
                    :index="index"
                    :stageName="stageName"
                    :countryLangMapping="countryAndLanguages"
                    :hideEmptyTranslations="hideEmptyTranslations"
                    :getViewOption="getViewOption"
                    :selectedViewOption="selectedViewOption"
                    :emitUpdatedMessage="emitUpdatedMessage"
                    :validateMessage="validateMessage"
                    v-on:deleteMessage="deleteMessage"
                    v-on:updateMessage="updateMessage"
                    v-on:updateMessageValidation="updateMessageValidation"
                  />  
                </tr>
              </draggable>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEqual, merge } from 'lodash'
import draggable from 'vuedraggable'
import { viewOptions } from './constant'
import { getActiveCountryList, getDisplayMessage } from '../../../utils/utilities'
import convoMessage from './convoMessage.vue'
export default {
  name: 'message-set',
  props: ['allMessages', 'mediaType', 'countryAndLanguages', 'stageName'],
  components: {
    draggable,
    'message': convoMessage
  },
  data () {
    return {
      messageSet: this.allMessages,
      formattedMessageSet: this.formatMessageSet(this.allMessages),
      hideEmptyTranslations: false,
      languages: [],
      viewOptions: viewOptions, // 0 - Expand All, 1 - Collapse All
      selectedViewOption: 0,
      emitUpdatedMessage: false,
      validateMessage: {
        mediaType: this.mediaType,
        shouldCheckValidation: false
      },
      activeCountryList: [],
      areMessagesValid: false,
      errorMessages: [],
      showNewFeaturePrompt: false,
      showTextInfoForButton: '{{item1}} {{item2}} {{item3}}',
      showTextInfoForList: '{{item1}} {{item2}} {{item3}} {{item4}} [[ListButtonText]]',
      showTextInForPharmacyName: '{{PHARMACY_NAME}}',
      showTextInForUserName: '{{USER_NAME}}',
      showTextInfoForUserLocation: '{{USER_LOCATION}}',
      showTextInfoForMapOfReferral: '{{LINK_FOR_GOOGLE_MAP}}',
      showTextInfoForMSKLink: '{{MSK_RESOURCE_LINK}}',
      showTextInfoForAccountId: '{{ACCOUNT_ID}}',
      showTextInfoForGiftCard: '{{GIFT_CARD_150}}',
      showTextInfoForAirtime: '{{SEND_AIRTIME_10}}',
      showTextInfoForDigitalVoucher: '{{NIVI_DIGITAL_VOUCHER}}',
      showTextInfoForNinetyForAppointment: '{{NINETY_CLINIC_NAME}} {{NINETY_BOOKING_DATE}} {{NINETY_BOOKING_TIME}} {{NINETY_BOOKING_ID}}',
      showTextInForProviderCode: '{{PROVIDER_CODE}}'
    }
  },
  async mounted () {
    this.activeCountryList = await getActiveCountryList('lowercase', true)
    // Built before the country list arrived, so redo it in the right order. Nothing is edited yet.
    this.formattedMessageSet = this.formatMessageSet(this.allMessages)
  },
  methods: {
    toggledRadio (val) {
      // Clearing error messages so that message doesn't always stay open
      this.errorMessages = []
    },
    showInfoPopUp (event) {
      event.preventDefault()
      event.stopPropagation()
      this.showNewFeaturePrompt = true
    },
    closeNewFeatureModal () {
      this.showNewFeaturePrompt = false
    },
    addMessage () {
      const emptyMessageObject = this.getEmptyMessageObject()
      this.formattedMessageSet.push(emptyMessageObject)
      this.hideEmptyTranslations = false
    },
    getEmptyMessageObject () { // generates empty message object with all available country-language pairing
      let emptyMessageObject = {}
      for (let country in this.countryAndLanguages) {
        if (this.activeCountryList.includes(country.toLowerCase())) emptyMessageObject[country] = {}
        else continue
        for (let lang of this.countryAndLanguages[country]) {
          emptyMessageObject[country][lang.alias] = ''
        }
      }
      return this.orderMessage(this.formatMessage(emptyMessageObject))
    },
    // English rows first, then the other languages; within each, Global and then the active
    // countries in their configured order, then anything else.
    orderMessage (message) {
      const rank = key => {
        const position = this.activeCountryList.indexOf(this.getCountryName(key).toLowerCase())
        return (key.endsWith('-eng') ? 0 : 1000) + (position === -1 ? 999 : position)
      }
      const ordered = {}
      Object.keys(message).sort((a, b) => rank(a) - rank(b)).forEach(key => { ordered[key] = message[key] })
      return ordered
    },
    async deleteMessage (index) {
      const result = await this.buttonDialog('Are you sure you want to delete this message?', 'Yes', 'No')
      if (!(result.dismiss && result.dismiss === 'cancel')) this.formattedMessageSet.splice(index, 1)
    },
    async buttonDialog (title, confirmButtonText, cancelButtonText) {
      return this.$swal({
        title,
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },
    // This method will convert: [{"India":{"hi":"kaise ho","eng":"how are you?"}] to [{"India-eng":{"eng":"how are you?"},"India":{"hi":"kaise ho"}}]
    // That is, will convert eng language to new object and place it at the top of array in every message of messageSet
    formatMessageSet (messageSet) {
      let formattedMessageSet = []
      for (let message of messageSet) { // iteration over array
        const emptyMessageObject = this.getEmptyMessageObject()
        const formattedMessage = this.formatMessage(message)
        // Instead of combining with spread operator (shallow copy), we are using lodash merge to deep copy and not lose empty language key
        // which is inside country object.emptyMessageObject will be having but not formattedMessage
        const mergedObject = merge(emptyMessageObject, formattedMessage)
        formattedMessageSet.push(this.orderMessage(mergedObject)) // To fill in empty translations we add emptyMessageObject
      }
      return formattedMessageSet
    },
    formatMessage (message) {
      let regionalMessage = {}
      let englishMessage = {}
      for (let country in message) { // iteration over object key
        if (country === 'properties') continue
        for (let lang in message[country]) { // iteration over object key
          if (lang !== 'eng') {
            if (!regionalMessage[country]) regionalMessage[country] = {} // Create object only if data is there
            regionalMessage[country][lang] = message[country][lang]
          } else {
            if (!englishMessage[`${country}-eng`]) englishMessage[`${country}-eng`] = {} // Create object only if data is there
            englishMessage[`${country}-eng`]['eng'] = message[country][lang]
          }
        }
      }
      return {...englishMessage, ...regionalMessage}
    },
    async isMessageSetEdited () {
      // Trigger messages to send updated message and wait for few milliseconds to get latest formatted message
      this.emitUpdatedMessage = true
      await new Promise(resolve => setTimeout(resolve, 300))
      if (this.emitUpdatedMessage) this.emitUpdatedMessage = false // This moved after promise as quick update on next line not detected in watch of message component
      let originalFormattedMessageSet = this.formatMessageSet(this.allMessages)
      if (this.hideEmptyTranslations) { // generate display message format
        for (let [index, message] of originalFormattedMessageSet.entries()) {
          originalFormattedMessageSet[index] = getDisplayMessage(message, true)
        }
      }
      for (let [index, message] of this.formattedMessageSet.entries()) {
        this.formattedMessageSet[index] = getDisplayMessage(message, true)
      }
      return !isEqual(JSON.parse(JSON.stringify(this.formattedMessageSet)), JSON.parse(JSON.stringify(originalFormattedMessageSet)))
    },
    updateMessage (updatedMessage) {
      const index = updatedMessage.index
      const message = {...updatedMessage.displayMessage}
      for (const [country, value] of Object.entries(this.formattedMessageSet[index])) {
        if (!(country in message)) {
          message[country] = value
        } else {
          message[country] = Object.assign({}, value, message[country])
        }
      }
      // The display copy leaves out hidden empty languages, which were then added back at the end
      this.formattedMessageSet[index] = this.orderMessage(message)
    },
    updateMessageValidation (valid) {
      const isValid = valid.isValid
      if (!isValid) this.errorMessages = [...this.errorMessages, valid.index]
      this.areMessagesValid = this.areMessagesValid && isValid
    },
    async validMessages () {
      this.areMessagesValid = true
      this.errorMessages = []
      // Trigger messages to send check for validation
      this.validateMessage = {...this.validateMessage, shouldCheckValidation: true}
      await new Promise(resolve => setTimeout(resolve, 300))
      this.validateMessage = {...this.validateMessage, shouldCheckValidation: false} // Restoring to false, in order that validations don't keep on firing on mediaType change. Check mediaType watcher
      return this.areMessagesValid
    },
    // This will be the reverse of formatMessageSet method to send proper response in API
    async getParsedMessageSet () {
      // Trigger messages to send updated message and wait for few milliseconds to get latest formatted message
      this.emitUpdatedMessage = true
      await new Promise(resolve => setTimeout(resolve, 500))
      if (this.emitUpdatedMessage) this.emitUpdatedMessage = false // THis moved after promise as quick update on next line not detected in watch of message component
      let parsedMessageSet = []
      for (let message of this.formattedMessageSet) {
        let parsedMessage = {}
        for (let country in message) {
          let nonEmptyCountryMessage = {}
           // we have taken oringal name as this method will join India-eng and India country to India key.
           // India-eng and India would be 2 countries in formattedMessageSet
          const originalCountryName = this.getCountryName(country)
          for (let lang in message[country]) {
            if (message[country][lang].length > 0) {
              // Create new country index only if there is any data for any of the language
              if (!nonEmptyCountryMessage[originalCountryName]) nonEmptyCountryMessage[originalCountryName] = {}
              nonEmptyCountryMessage[originalCountryName][lang] = message[country][lang]
            }
          }
          if (Object.keys(nonEmptyCountryMessage).length > 0) {
            let countryMessageInParsedMessage = {}
            if (parsedMessage[originalCountryName]) countryMessageInParsedMessage = parsedMessage[originalCountryName]
            else parsedMessage[originalCountryName] = {}
            parsedMessage[originalCountryName] = {...countryMessageInParsedMessage, ...nonEmptyCountryMessage[originalCountryName]}
          }
        }
        parsedMessageSet.push(parsedMessage)
      }
      return parsedMessageSet
    },
    getCountryName: function (value) {
      if (value.split('-').length > 1) return value.split('-')[0]
      return value
    },
    getViewOption: function (index) {
      if (this.selectedViewOption === 0) return 0
      else {
        if (this.errorMessages.includes(index)) return 0
        return 1
      }
    }
  },
  watch: {
    allMessages: function (value) {
      this.messageSet = [...value]
      this.formattedMessageSet = [...this.formatMessageSet(value)]
      this.hideEmptyTranslations = true
    },
    mediaType: function (value) {
      this.mediaType = value
      this.validateMessage = { ...this.validateMessage, mediaType: value }
    }
  }
}
</script>
<style scoped>
.message-set-header {
  display: flex;
  justify-content: space-between;
  margin: 0 0 12px;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.add-message-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  flex-grow: 1;
  min-width: 300px;
}
.btn-add-message {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border-radius: 8px;
  font-weight: 700;
  background-color: #0D9488;
  border-color: #0D9488;
  color: white;
  box-shadow: 0 2px 8px -2px rgba(13, 148, 136, 0.3);
}
.btn-add-message:hover,
.btn-add-message:focus {
  background-color: #0B7C72;
  border-color: #0B7C72;
  color: white;
}
/* Expand All / Collapse All as a segmented control */
.view-option {
  display: inline-flex;
  padding: 3px;
  border-radius: 9px;
  background: #F5F7FA;
  border: 1px solid #E2E8F0;
}
.view-option-radio {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  padding: 4px 10px;
  border-radius: 7px;
  color: #5C6E8A;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.view-option-radio input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.view-option-radio--active {
  background: #FFFFFF;
  color: #1E3A5F;
  box-shadow: 0 1px 3px rgba(30, 58, 95, 0.1);
}
.hide-empty-translation {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 0 auto;
  color: #5C6E8A;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
}
.hide-empty-translation input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.hide-empty-translation__track {
  position: relative;
  flex-shrink: 0;
  width: 28px;
  height: 16px;
  border-radius: 999px;
  background: #CFD8E3;
  transition: background-color 0.15s ease;
}
.hide-empty-translation__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0 1px 2px rgba(30, 58, 95, 0.25);
  transition: transform 0.15s ease;
}
.hide-empty-translation--on {
  color: #1E3A5F;
}
.hide-empty-translation--on .hide-empty-translation__track {
  background: #0D9488;
}
.hide-empty-translation--on .hide-empty-translation__thumb {
  transform: translateX(12px);
}
.message-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 28px 16px;
  border: 1px dashed #CFD8E3;
  border-radius: 10px;
  color: #8896A5;
  text-align: center;
}
.message-empty .fa {
  font-size: 24px;
}
.message-list {
  width: 100%;
}
.message-list tr {
  background: transparent;
}
.collapsable-icon-container{
  display: flex;
  justify-content: center;
  align-items: center;
}
.new-feature {
  position: relative;
  margin-bottom: auto;
  margin-right: 120px;
}
.header-style {
  display: flex;
  justify-content: center;
  align-items: center;
}
.style-button-section{
  margin-top: -26px;
}
.style-list-section {
  margin-top: 20px;
}
.style-select-options {
  margin-top: 10px;
}
.style-template-text {
  margin-top: 15px;
}
.style-new-icon {
  margin-left: 15px;
}
.modal-body {
  position: relative;
  min-height: 315px;    
}
</style><style scoped>
/* Message Sets header: the whole bar toggles it, the chevron shows whether it's open. */
.panel-heading .collapsable-link-panel {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 11px 16px;
  text-align: left;
  font-size: 15px;
}
.panel-heading .collapsable-link-panel .style-new-icon {
  margin-left: auto;
  margin-right: 12px;
  line-height: 1;
}
.panel-heading .collapsable-link-panel::after {
  content: '\f078';
  font-family: FontAwesome;
  font-size: 12px;
  opacity: 0.8;
  transition: transform 0.15s ease;
}
.panel-heading .collapsable-link-panel.collapsed::after {
  transform: rotate(-90deg);
}
</style>



// WEBPACK FOOTER //
// messageSet.vue?588afb69